import Login from "../../components/Login";
import "./Users.css";

export default function LoginPage() {
  return (
    <div className="login-main">
      <Login />
    </div>
  );
}
